/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_PlatformInputs */

const en_portal_scanner_platform = /** @type {(inputs: Portal_Scanner_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const de_portal_scanner_platform = /** @type {(inputs: Portal_Scanner_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const fr_portal_scanner_platform = /** @type {(inputs: Portal_Scanner_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const es_portal_scanner_platform = /** @type {(inputs: Portal_Scanner_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const it_portal_scanner_platform = /** @type {(inputs: Portal_Scanner_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const nl_portal_scanner_platform = /** @type {(inputs: Portal_Scanner_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const pl_portal_scanner_platform = /** @type {(inputs: Portal_Scanner_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const fi_portal_scanner_platform = /** @type {(inputs: Portal_Scanner_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const da_portal_scanner_platform = /** @type {(inputs: Portal_Scanner_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const sv_portal_scanner_platform = /** @type {(inputs: Portal_Scanner_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

/**
* | output |
* | --- |
* | "Platform" |
*
* @param {Portal_Scanner_PlatformInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_platform = /** @type {((inputs?: Portal_Scanner_PlatformInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_PlatformInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_platform(inputs)
	if (locale === "fr") return fr_portal_scanner_platform(inputs)
	if (locale === "es") return es_portal_scanner_platform(inputs)
	if (locale === "it") return it_portal_scanner_platform(inputs)
	if (locale === "nl") return nl_portal_scanner_platform(inputs)
	if (locale === "pl") return pl_portal_scanner_platform(inputs)
	if (locale === "fi") return fi_portal_scanner_platform(inputs)
	if (locale === "da") return da_portal_scanner_platform(inputs)
	if (locale === "sv") return sv_portal_scanner_platform(inputs)
	return en_portal_scanner_platform(inputs)
});